// src/pages/Ayarlar.js

import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import Hizmetler from '../components/Hizmetler';
import SmsYonetimi from './SmsYonetimi';
import AracMarkaModel from '../components/AracMarkaModel';
import KullaniciYonetimi from '../components/KullaniciYonetimi';
import { useAuth } from '../context/AuthContext';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`ayarlar-tabpanel-${index}`}
      aria-labelledby={`ayarlar-tab-${index}`}
      {...other}
    >
      {value === index && (<Box sx={{ p: 3 }}>{children}</Box>)}
    </div>
  );
}

const Ayarlar = () => {
  const { currentUser } = useAuth();
  const [tabValue, setTabValue] = useState(0);

  const isGenelMudur = currentUser?.role === 'Genel Müdür';

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Genel Ayarlar
      </Typography>
      <Paper>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleChange} aria-label="Ayarlar Sekmeleri" variant="scrollable" scrollButtons="auto">
            <Tab label="Hizmet/Ürün Listesi" id="ayarlar-tab-0" />
            <Tab label="Araç Marka/Model" id="ayarlar-tab-1" />
            <Tab label="SMS Yönetimi" id="ayarlar-tab-2" />
            {isGenelMudur && <Tab label="Kullanıcı Yönetimi" id="ayarlar-tab-3" />}
          </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0}>
          <Hizmetler />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AracMarkaModel />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <SmsYonetimi />
        </TabPanel>
        {isGenelMudur && (
          <TabPanel value={tabValue} index={3}>
            <KullaniciYonetimi />
          </TabPanel>
        )}
      </Paper>
    </Box>
  );
};

export default Ayarlar;